<div class="header d-flex justify-content-between align-items-center fixed-top">
    <span class="d-flex align-items-center logo-section">
        <a routerLink="../home" class="p-2 flex-grow-1 ml-10 desktop-home-href"><img width="160px" src="assets/images/BH_logo_1_light.png" /></a>
        <a class="p-2 flex-grow-1 ml-10 mobile-home-href"><img width="160px" src="assets/images/BH_logo_1_light.png" /></a>
    </span>

    <span class="d-flex align-items-center">
        <app-notification-bell *ngIf="showNotifications"></app-notification-bell>
        <a mat-icon-button class="doc-anchor-link mr-8" [href]="appLinks.INTERCOM_DOC" target="_blank" aria-label="Documentation">
            <mat-icon class="text-white material-icons-outlined">help_outline</mat-icon>
        </a>
        <button mat-icon-button class="mr-16" [matMenuTriggerFor]="beforeMenu">
            <mat-icon class="text-white" fontSet="material-icons-outlined">account_circle</mat-icon>
        </button>
    </span>

    <mat-menu #beforeMenu="matMenu" xPosition="before" class="action-menu-panel">
        <div class="profile-name">
            <div class="px-16 py-12">Welcome, {{profileName}}!</div>
            <mat-divider></mat-divider>
        </div>
        <button mat-menu-item (click)="logOut()">Sign out</button>
    </mat-menu>
    <mat-progress-bar *ngIf="isLoading$ | async" mode="indeterminate"></mat-progress-bar>
</div>
